import React from 'react';
import ofisImage from '../projectitems/ofis.png';

const About = () => {
    const scrollTo = (id) => {
        const el = document.querySelector(id);
        if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    return (
        <section className="about" id="terra">
            <div className="about__container">
                <div className="about__visual">
                    <img src={ofisImage} alt="Arth Yapı Ofis" className="about__image" />
                </div>

                <div className="about__content">
                    <p className="section-eyebrow">Hakkımızda</p>
                    <h2 className="section-title">ARTH YAPI</h2>
                    <div className="about__divider" />
                    <p className="about__text">
                        <strong>Arth Yapı</strong>, mimarlık ve tasarım alanında seçkin projelere imza atan, estetik anlayışı yüksek ve detay odaklı bir mimarlık ofisidir. Zamansız tasarım dili, yenilikçi yaklaşımı ve üst düzey kalite standartlarıyla ayrıcalıklı yaşam alanları üretir.
                    </p>
                    <p className="about__text">
                        Her proje, Arth Yapı için bir tasarım manifestosudur. Müşterilerimizin vizyonunu en ince ayrıntısına kadar analiz eder, mimariyi sanat ve mühendislikle buluşturarak özgün yapılar ortaya çıkarırız. Seçkin malzemeler, rafine detaylar ve kusursuz işçilik anlayışıyla mekanları yalnızca inşa etmiyor; prestijli bir yaşam deneyimine dönüştürüyoruz.
                    </p>
                    <p className="about__text">
                        Mimari proje tasarımı, iç ve dış mekan planlaması, renovasyon ve anahtar teslim uygulama süreçlerinde uçtan uca hizmet sunarak, her aşamada mükemmeliyet ilkesini benimsiyoruz. Arth Yapı, yalnızca yapılar tasarlamaz; kalıcı değer ve ayrıcalık inşa eder.
                    </p>
                    <blockquote className="about__quote">
                        "Kişiselleştirilmiş mekanlar için Arth Yapı."
                    </blockquote>
                    <button className="btn btn--primary" onClick={() => scrollTo('#urunler')}>
                        ÜRÜN KATALOĞU
                    </button>
                </div>
            </div>
        </section>
    );
};

export default About;
